export const DEFAULT_DEBOUNCE_TIME = 300; // in ms

export default DEFAULT_DEBOUNCE_TIME;
